<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import VehicleFormCard from '@/components/vehicle/VehicleCard.vue'
import { type Vehicle } from '@/types/Vehicle'
import { useTransactionStore } from '@/stores/transactionStoreOld'

const props = defineProps<{ transactionId: string }>()
const transactionStore = useTransactionStore()
const transaction = computed(() => transactionStore.draft)
const vehicle = ref<Vehicle | null>(
  transaction.value?.vehicleSnapshot
    ? {
        ...transaction.value.vehicleSnapshot,
        createdAt: new Date(),
        updatedAt: new Date(),
      }
    : null,
)

watch(vehicle, async (val) => {
  if (val && transaction.value?.id) {
    await transactionStore.updateDraft({
      vehicleId: val.id ?? undefined,
      vehicleSnapshot: {
        tagNumber: val.tagNumber,
        state: val.state,
        year: val.year ?? undefined,
        make: val.make ?? undefined,
        model: val.model ?? undefined,
        color: val.color ?? undefined,
        vin: val.vin ?? undefined,
        notes: val.notes ?? undefined,
      },
    })
  }
})
</script>

<template>
  <VehicleFormCard v-model="vehicle" />
</template>
